export default {
  setEmail(state, email) {
    state.email = email
  },
  setName(state, name) {
    state.name = name
  },
  setPassword(state, password) {
    state.password = password
  },
  setPasswordConfirmation(state, password_confirmation) {
    state.password_confirmation = password_confirmation
  },
  setToken(state, token) {
    state.token = token
  },
  setRecaptchaToken(state, recaptchaToken) {
    state.recaptchaToken = recaptchaToken
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/register/mutations.js